var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "mt-12",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "left",
          },
        },
        [
          _c(
            "div",
            [
              _c("h2", { staticClass: "payout-second-title" }, [
                _vm._v(_vm._s(_vm.$t("merchantAccount.beneficiary_details"))),
              ]),
              _c(
                "el-form-item",
                {
                  staticClass: "mt-12",
                  attrs: {
                    label: _vm.$t("merchantAccount.beneficiary") + ":",
                    prop: "beneficiary_id",
                    rules: [
                      {
                        required: true,
                        message: "Beneficiary cannot be empty",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("br"),
                  _c(
                    "el-select",
                    {
                      staticClass: "from-input",
                      attrs: {
                        disabled: _vm.id_disabled,
                        placeholder: _vm.$t("merchantAccount.beneficiary"),
                        clearable: "",
                      },
                      on: { change: _vm.onChangeBeneficiaryList },
                      model: {
                        value: _vm.form.beneficiary_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "beneficiary_id", $$v)
                        },
                        expression: "form.beneficiary_id",
                      },
                    },
                    _vm._l(_vm.beneficiaryList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.$store.getters.curCountry.country_code === "TH"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("merchantAccount.beneficiary_account_type") +
                          ":",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.beneficiaryAccountTypeFormat(
                              _vm.merchantInfo.beneficiary_account_type
                            )
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.$store.getters.curCountry.country_code === "TH" &&
              _vm.merchantInfo.beneficiary_account_type === "PROMPTPAY"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("merchantAccount.beneficiary_type") + ":",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.beneficiaryTypeFormat(
                              _vm.merchantInfo.beneficiary_type
                            )
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.$store.getters.curCountry.country_code !== "TH" ||
              _vm.merchantInfo.beneficiary_account_type === "BANK"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("merchantAccount.receiving_channel") + ":",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.merchantInfo.disbursement_channel) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("merchantAccount.beneficiary_name") + ":",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.merchantInfo.disbursement_name) + " ")]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.$t("merchantAccount.beneficiary_account_no") + ":",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.merchantInfo.disbursement_number) + " "
                  ),
                ]
              ),
              _vm.$store.getters.curCountry.country_code === "AE"
                ? _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("map.benefit_address") + ":" } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.merchantInfo.beneficiary_address) + " "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("merchantAccount.amount_limit") + ":",
                  },
                },
                [
                  _vm.merchantInfo.disbursement_payout_limit_amount === 1
                    ? _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                _vm.merchantInfo.contract_amount
                              )
                            ) +
                            " "
                        ),
                      ])
                    : _c("div", [_vm._v(" / ")]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("h2", { staticClass: "payout-second-title" }, [
                _vm._v(_vm._s(_vm.$t("merchantAccount.payment_details"))),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("merchantAccount.merchant_order_id"),
                    prop: "merchant_order_id",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "from-input",
                    attrs: {
                      maxlength: "32",
                      "show-word-limit": "",
                      placeholder: "Enter merchant order ID",
                      type: "text",
                      autocomplete: "off",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.merchant_order_id,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "merchant_order_id",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.merchant_order_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("components.amount"),
                    prop: "amount",
                    rules: [
                      {
                        required: true,
                        message: "Amount cannot be empty",
                        trigger: ["blur", "change"],
                      },
                      {
                        validator: _vm.checkAmount,
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "from-input",
                    attrs: {
                      type: "text",
                      placeholder: "Enter amount",
                      autocomplete: "off",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "amount", $$v)
                      },
                      expression: "form.amount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "450px" },
                  attrs: {
                    required: "",
                    label: _vm.$t("merchantAccount.payment_remark") + ":",
                    prop: "remark",
                  },
                },
                [
                  _c("br"),
                  _c("el-input", {
                    staticClass: "from-input",
                    staticStyle: { width: "450px" },
                    attrs: {
                      placeholder: "Enter your message here",
                      type: "textarea",
                      maxlength: "256",
                      clearable: "",
                      "overflow:": "",
                      auto: "",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _vm.$store.getters.isOpenMfa
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "450px" },
                      attrs: {
                        label: _vm.$t("system.mfa_verify_code") + ":",
                        prop: "mfa_code",
                        required: "",
                      },
                    },
                    [
                      _c("br"),
                      _c("el-input", {
                        staticClass: "search-frame",
                        attrs: {
                          placeholder: "Enter your MFA verification code",
                          maxlength: "6",
                          autocomplete: "off",
                          clearable: "",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.mfa_code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mfa_code", $$v)
                          },
                          expression: "form.mfa_code",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "cp-btn" },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onClickCancelBtn } },
            [_vm._v(_vm._s(_vm.$t("components.cancel")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "confirm-btn",
              attrs: { type: "info", disabled: _vm.submiting },
              on: { click: _vm.onClickSubmitBtn },
            },
            [_vm._v(_vm._s(_vm.$t("components.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }